import { LoginComponent } from './views/login/login.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { UploadFileToS3Component } from './views/upload-s3/upload-file-to-s3.component';


const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'formqua007', loadChildren: () => import('./modules/form-qua007.module').then(m => m.FormQua007Module) },
  { path: 'formrs009', loadChildren: () => import('./modules/form-rs009.module').then(m => m.FormRs009Module) },
  { path: 'formsec002', loadChildren: () => import('./modules/form-sec002.module').then(m => m.FormSec002Module) },
  { path: 'formcd001/:area', loadChildren: () => import('./modules/form-cd001.module').then(m => m.FormCd001Module) },
  { path: 'formrs005', loadChildren: () => import('./modules/form-rs005.module').then(m => m.FormRs005Module) },
  { path: 'formcd003', loadChildren: () => import('./modules/form-cd003.module').then(m => m.FormCd003Module) },
  { path: 'formet004', loadChildren: () => import('./modules/form-et004.module').then(m => m.FormEt004Module) },
  { path: 'formqua042', loadChildren: () => import('./modules/form-qua042.module').then(m => m.FormQua042Module) },
  { path: 'formcd006', loadChildren: () => import('./modules/form-cd006.module').then(m => m.FormCd006Module) },
  { path: 'formmake745', loadChildren: () => import('./modules/form-make745.module').then(m => m.FormMake745Module) },
  { path: 'camisa-trieur', loadChildren: () => import('./modules/form-camisa-trieur-module').then(m => m.FormCamisaTrieurModule) },
  { path: 'formule-config', loadChildren: () => import('./views/formule-config/formule-config.module').then(m => m.FormuleConfigModule) },
  { path: 'rule-config', loadChildren: () => import('./views/rule-config/rule-config.module').then(m => m.RuleConfigModule) },
  { path: 'manageSequence', loadChildren: () => import('./modules/form-sequenceManage.module').then(m => m.FormSequenceManageModule) },
  { path: 'login', component: LoginComponent },
  { path: 'uploadFileToS3', component: UploadFileToS3Component },
  { path: 'adm', loadChildren: () => import('./views/adm/adm.module').then(m => m.AdmModule) },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
];

@NgModule({
  imports: [HttpClientModule, RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', useHash: true })],
  exports: [RouterModule]
})

export class AppRoutingModule {

}
